<template>
  <div class="on-board-requirements text-white">
    <h2 class="mb-4 pt-2 text-center mt-4">
      {{ "onboard.requirements.title" | trans }}
    </h2>

    <div class="text-center mb-3">
      <app-avatar :name="fullName" :url="avatarUrl" size="sm" class="mb-2" />
      <div class="ml-3 overflow-hidden">{{ email }}</div>
    </div>

    <app-button block href="#" @click="onChangeUser">
      <i class="icon icon-arrow-left"></i>
      {{ "onboard.requirements.button.change_user.label" | trans }}
    </app-button>

    <p>{{ "onboard.requirements.desc" | trans }}</p>

    <app-accordion v-model="expandedIndex">
      <app-personal-data v-model="valid.personalData" />
      <app-account-confirmation v-model="valid.accountConfirmation" />
    </app-accordion>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AppAccordion from "@/components/ui/Accordion/Accordion";
import AppAvatar from "@/components/user/Avatar";
import AppButton from "@/components/ui/Button";
import AppPersonalData from "@/views/Account/OnBoard/Requirements/PersonalData";
import AppAccountConfirmation from "@/views/Account/OnBoard/Requirements/AccountConfirmation";

export default {
  name: "OnBoardRequirementsView",
  components: {
    AppAccountConfirmation,
    AppPersonalData,
    AppButton,
    AppAvatar,
    AppAccordion,
  },
  computed: {
    ...mapGetters("customers", ["customer"]),
    email() {
      return this.customer.email;
    },
    avatarUrl() {
      return this.customer.avatarUrl;
    },
    fullName() {
      return this.customer.fullName;
    },
    isValid() {
      return (
        Object.keys(this.valid).findIndex(key => this.valid[key] === false) < 0
      );
    },
  },
  methods: {
    async onChangeUser() {
      await this.$auth.logout();
      this.$router.push({ name: "login" });
    },
  },
  watch: {
    valid: {
      handler(value) {
        this.expandedIndex = Object.keys(value).findIndex(
          key => value[key] === false
        );
      },
      immediate: true,
      deep: true,
    },
    isValid(value) {
      if (!value) {
        return;
      }

      this.$router.push({ name: "my-plane" });
    },
  },
  data() {
    return {
      expandedIndex: 1,
      valid: {
        personalData: false,
        accountConfirmation: false,
      },
    };
  },
};
</script>
